/**
 * colsSettingParam 参数的说明和取的位置：

 *  应用编码 appcode    引入src/api/pageTo  pageTo.getAppCode()

*  页面编码 pagecode   引入src/api/pageTo  pageTo.getAppCode()

*  模板编码code        拿到整个页面的模板template template.code为模板编码

*  模板主键pageid      拿到整个页面的模板template template.pageid 为模板主键

*   区域编码areaCode    拿到整个页面的模板template areaCode是表格的区域编码 template[areaCode]可以拿到表格区域的模板信息

*   区域主键areaId      模板信息里的属性oid的值

 */
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import Checkbox from '../../Checkbox';
import { ajax, toast, removeMetaCache, isFunction, getGlobalStorage, setGlobalStorage, removeGlobalStorage } from '@platform/api';
import ColSettingSideBox from './colSettingSideBox';
import 'bee-drawer/build/Drawer.css';

export default class ColumnMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secondColumnShow: false, //自定义鼠标右键菜单显示
            showDrawer: false, //侧拉显示
            displayData: [], //左侧待选列显示模板
            sortData: [], //被选择排序的列显示模板
            columnsHaveTitle: [],
            rightData: [],
        };
        this.lockTotal = 0; //被锁定不能拖拽的列个数
        //this.keySessionS = ''; //localStorage缓存页面模板的key
    }

    componentDidMount() {
        // let { colsSettingParam } = this.props;
        // let { appcode, pagecode } = colsSettingParam;
        // //console.log("------------当前页面的pagecode为:" + pagecode)
        // //this.keySessionS = 'appTempletStorage_' + appcode + '_' + pagecode;
    }

    onMouseEnter = () => {
        this.setState({ secondColumnShow: true });
    };

    onMouseLeave = () => {
        this.setState({ secondColumnShow: false });
    };

    // 获取所有的非一级表头 
    getChildrenColumns(columns) {
        let newColumns = [];
        columns.map(item => {
            item._level > 1 && newColumns.push(item.attrcode);
        });
        return newColumns;
    }

    //发送请求获取模板取title 执行保存callback
    getColIncludeTitle = (isAsync = true, includeChildren = true, callback) => {
        let { colsSettingParam, columns } = this.props;
        let newColumns = columns.filter(val => (val.itemtype !== 'customer'));
        //tableType:是什么高阶表格
        //tabName:cardtable的页签名字
        let { appcode, pagecode, code, pageid, areaCode, tableType, tabName, hiddenLeftItem } = colsSettingParam;
        let finalAreaCode = areaCode;
        //用于兼容cardtable多页签
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        ajax({
            url: '/nccloud/platform/template/getUserTemplateMap.do',
            async: isAsync,
            data: {
                appcode,
                pagecode,
                templatecode: code,
                templateId: pageid,
            },
            success: res => {
                // 获取左侧模板全部数据
                let areaList = res.data[0].areaList;
                //获取右侧表格显示数据
                let rightData = res.data[1][finalAreaCode].items;
                let items = areaList.filter(item => item.code == finalAreaCode)[0].formPropertyList;
                let cols =
                    items &&
                    items.map(val => {
                        val.title = val.label || val.display || val.value;
                        val.attrcode = val.code;
                        return val;
                    });
                let columnsHaveTitle = cols.filter(val => {
                    if (hiddenLeftItem && hiddenLeftItem.length) {
                        return (val.visible === true && !hiddenLeftItem.includes(val.attrcode))
                    } else {
                        return val.visible === true
                    }
                });
                
                //是否有自定义项
                let flag = newColumns.length !== items.length;
                let userDefineItems = [];
                if (flag) {
                    let rightAttrcode = newColumns.map(item => item.attrcode);
                    cols.map(item => {
                        if (rightAttrcode.includes(item.attrcode) && item.visible === false) {
                            userDefineItems.push(item);
                        }
                    });
                }
                if (flag) {
                    newColumns.map((val, index) => {
                        userDefineItems.map(item => {
                            if (item.attrcode === val.attrcode) {
                                columnsHaveTitle.splice(index, 0, item);
                            }
                        });
                    });
                }
                // 如果不需要包含二级表头，那就把二级表头过滤掉
                if (!includeChildren) {
                    // 拿出来所有的二级表头
                    let childrenColumns = this.getChildrenColumns(newColumns);
                    // 筛选出一级表头的列
                    columnsHaveTitle = columnsHaveTitle.filter(item => {
                        return (childrenColumns.indexOf(item.attrcode) == -1);
                    });
                }

                this.setState(
                    {
                        columnsHaveTitle,
                        rightData,
                        userDefineItems,
                    },
                    () => {
                        if (typeof callback === 'function') callback(columnsHaveTitle);
                    },
                );
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //显示侧拉
    toShowDrawer = () => {
        let { colsSettingParam, columns } = this.props;

        this.lockTotal = 0;
        if (colsSettingParam) {
            //支持列设置的表格，从props取模板信息；取不到之后再发向后端获取
            if (columns) {

                let { hiddenLeftItem } = colsSettingParam;
                let newColumns = columns.filter(val => {
                    if (hiddenLeftItem?.length) {
                        // 业务组会隐藏某些列
                        //changeMetaCol为了解决NCC-43188，改了模板，把itemtype改成customer
                        return (val.itemtype !== 'customer' || val.changeMetaCol === true) && !hiddenLeftItem.includes(val.attrcode) && (!val._level || (val._level && val._level< 2))
                    } else {
                        return ((val.itemtype !== 'customer' || val.changeMetaCol === true) && (!val._level || (val._level && val._level< 2)))
                    }

                });

                columns.forEach(val => {
                    if (val.islock) this.lockTotal++;
                });
                newColumns.forEach(val => {
                    val.width = String(val.width);
                    val.visible = true;
                    val.isLock = val.fixed === 'left';
                    if (val.fixed) delete val.fixed;
                });
                this.sortData = [...newColumns];
                this.getColIncludeTitle(true, false, items => {
                    //列设置
                    let userItems = this.state.userDefineItems.map(item => item.attrcode);
                    let newItems = items.map(val => {
                        //右侧已经存在则将左侧字段隐藏
                        val.showItem = true;
                        this.sortData.map((item, index) => {
                            if (item.attrcode == val.attrcode) {
                                if (item.visible === true) {
                                    val.showItem = false;
                                }
                                if (userItems.includes(val.attrcode)) {
                                    val.showItem = false;
                                    this.sortData[index].noDeletion = true;
                                }
                            }
                        });
                        return val;
                    });

                    this.setState({
                        displayData: [...newItems],
                        sortData: [...this.sortData],
                        showDrawer: true,
                    });
                });
                //   }
                // );
            }
        }
    };

    //关闭侧拉
    toCloseDrawer = () => {
        this.setState({ showDrawer: false });
        let element = ReactDOM.findDOMNode(this);
        if (element) {
            ReactDOM.unmountComponentAtNode(element);
            let parentElement = element.parentNode;
            parentElement && parentElement.removeChild(element);
        }
    };

    iconfontCls = (fontName, another) => {
        return `icon iconfont icon-${fontName} ${another}`;
    };

    /**
     * 请求失败关闭侧拉、提示错误信息
     */
    onRequestError = err => {
        this.toCloseDrawer();
        console.error(err);
        let msgContent = JSON.stringify(err.message);
        toast({
            color: 'danger',
            content: msgContent,
            mark: 'save-table-columnSetting',
        });
    };

    /**
     * 列设置重置或者保存成功以后，更新ncTable和高阶业务表格的column
     */
    // resetFlag true为重置列宽，重置列宽后需要把customer列也还原。 false保存列宽
    // saveTableWithFlag true为保存列宽 false保存列设置
    onSuccess = (metaColumns, successSMG, areaCode, resetFlag, saveTableWithFlag=true) => {
        // 保存itemtype = "customer" 的列列宽
        let { colsSettingParam } = this.props;
        let { appcode, pagecode } = colsSettingParam;
        let customerColumns = [];
        metaColumns.forEach(item=>{
            let { itemtype } = item;
            if( itemtype === "customer" ){
                customerColumns.push(item);
            }
        });
        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let customer_column_localStorage = 'customer_col_width_' + appcode + '_' + pagecode + '_' + areaCode + '_' + userid;
        if(resetFlag){
            // 重置列宽，重置列设置 清除customer列宽缓存
            removeGlobalStorage('localStorage', customer_column_localStorage);
        }else if(saveTableWithFlag){
            // 保存列宽 设置customer列宽缓存
            setGlobalStorage('localStorage', customer_column_localStorage, JSON.stringify(customerColumns));
        }

        let { updateColumnHandle } = this.props;
        this.toCloseDrawer();
        toast({ content: successSMG, light: true });
        updateColumnHandle(metaColumns, areaCode);
        // 卸载表格，重新加载 为了处理拖宽表格立即重置的情况
    };

    //保存列设置或者保存列宽的请求
    // saveTableWithFlag true为保存列宽 false保存列设置
    // 保存列宽里有customer列的信息 保存列设置里没有
    onSave = (metaColumns, ajaxColums, successSMG, saveTableWithFlag=true) => {
        let { colsSettingParam } = this.props;
        let { appcode, pagecode, code, pageid, areaCode, areaId, tableType, tabName } = colsSettingParam;
        let finalAreaCode = areaCode;
        
        //用于兼容cardtable多页签
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        ajax({
            url: '/nccloud/platform/template/propertySetting.do',
            data: {
                appcode,
                pagecode,
                templatecode: code,
                templateId: pageid,
                [finalAreaCode]: {
                    areaId,
                    items: ajaxColums,
                },
            },
            success: res => {
                if (res.success) {
                    let { colsSettingParam } = this.props;
                    let { appcode, pagecode } = colsSettingParam;
                    //removeGlobalStorage('localStorage', this.keySessionS); //在列设置保存之后，移除当页面模板缓存，在重新
                    removeMetaCache(appcode, pagecode);

                    this.onSuccess(metaColumns, successSMG, finalAreaCode, false, saveTableWithFlag);
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //点击侧拉header的确定按钮
    onColsSetting = sortData => {
        let { tableScope } = this.props;
        let { columnsHaveTitle } = this.state;
        let { json = {} } = tableScope.state;
        let metaColums = [],
            ajaxColums = [];
        // 重新设置列设置 添加重置列宽的标识
        // tableScope.resetWidthFlag = true;
        // 重新设置列设置 添加重置列宽的标识
        // tableScope.setCustomerColumnWidthFlag = true;
        sortData.map(val => {
            let { width, attrcode } = val;
            //前端默认拼的120默认宽度不保存到后端
            let ajaxWidthNS,
                metaWidthNS,
                title,
                propertyId;
            if (typeof width === 'string') {
                ajaxWidthNS = width.match(/\d+/g)[0];
                metaWidthNS = width.match(/\d+/g)[0];
            }
            // 后端不需要120px 前端需要
            if (ajaxWidthNS && (ajaxWidthNS == 120 || ajaxWidthNS == '120')) {
                ajaxWidthNS = undefined;
            }
            columnsHaveTitle.forEach(item => {
                if (attrcode === item.code) {
                    title = item.title;
                    propertyId = item.pk_form_property;
                }
            });
            let ajaxWidthObj = ajaxWidthNS ? { width: ajaxWidthNS } : {};
            let metaWidthObj = metaWidthNS ? { width: Number(metaWidthNS) } : {};
            let enableCol = this.deleteVDom(val);

            metaColums.push({
                ...enableCol,
                propertyId,
                ...metaWidthObj,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
            ajaxColums.push({
                ...enableCol,
                propertyId,
                ...ajaxWidthObj,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
        });
        let { rightData } = this.state;

        let ajaxItems =[];

        ajaxColums.map((ajaxItem, ajaxIndex) => {
            let oldItem = rightData.find(item=> item.attrcode === ajaxItem.attrcode);
            ajaxItems[ajaxIndex] = { ...oldItem, ...ajaxItem };
            oldItem.isLoop = true;
        });
        rightData.forEach(item => {
            if (item.isLoop) {
                delete item.isLoop;
            }else{
                ajaxItems.push(item);
            }
        });
        this.onSave(metaColums, ajaxItems, json['table_colseting_tip02'], false); //'列设置保存成功'
    };

    //点击重置 重置列设置
    onColReset = () => {
        let { colsSettingParam, tableScope } = this.props;
        let { appcode, pagecode, code, pageid, areaCode, tableType, tabName, hiddenLeftItem } = colsSettingParam;
        let { json = {} } = tableScope.state;
        // 兼容cardtable多页签
        let finalAreaCode = areaCode;
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        // 重置列设置也会把列宽重置 添加重置列宽的标识
        // tableScope.resetWidthFlag = true;
        // 重置列设置也会把列宽重置 添加重置列宽的标识
        // tableScope.setCustomerColumnWidthFlag = true;
        let url = '/nccloud/platform/template/removeUserPropertySettings.do';
        ajax({
            url,
            data: {
                templateId: pageid,
                areaId: finalAreaCode,
            },
            success: res => {
                if (res.success) {
                    ajax({
                        url: '/nccloud/platform/template/getUserTemplateMap.do',
                        data: {
                            appcode,
                            pagecode,
                            templatecode: code,
                            templateId: pageid,
                        },
                        success: result => {
                            //removeGlobalStorage('localStorage', this.keySessionS);
                            removeMetaCache(appcode, pagecode);

                            let areaList = result.data[0].areaList;
                            let rightData = result.data[1][finalAreaCode].items;
                            let { userDefineItems } = this.state;
                            let userItems = userDefineItems.map(item => item.attrcode);
                            let items = areaList.filter(item => item.code == finalAreaCode)[0].formPropertyList;
                            let metaColums = [];

                            rightData.map(data => {
                                items.map(item => {
                                    if (data.propertyId === item.pk_form_property) {
                                        let obj = data;
                                        let width = item.width ? (item.width.includes('px') ? item.width : item.width + 'px') : undefined;
                                        obj.width = width;
                                        if (userItems.includes(data.attrcode)) {
                                            obj.visible = true;
                                        }
                                        metaColums.push(obj);
                                    }
                                });
                            });
                            if (hiddenLeftItem && hiddenLeftItem.length) {
                                metaColums = metaColums.filter(val => !hiddenLeftItem.includes(val.attrcode))
                            }
                            this.onSuccess(metaColums, json['table_colseting_tip04'], finalAreaCode, true);
                        },
                        error: err => {
                            this.onRequestError(err);
                        },
                    });
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    //列宽保存
    onTableWithSave = () => {
        let { columns, tableScope } = this.props;
        let { columnsHaveTitle } = this.state;
        let { json = {} } = tableScope.state;
        // let { isTotal = false } = tableScope.props;

        // 列宽保存 添加保存列宽的标识
        tableScope.resetWidthFlag = true;
        // 列宽保存 添加保存列宽的标识
        tableScope.setCustomerColumnWidthFlag = true;
        let newColumns = columns.filter(item => {
            return item.attrcode !== 'blankrow';
        });
        // let newColumns = []
        // for (let index = 0; index < columns.length; index++) {
        //     const element = columns[index];
        //     if(element.attrcode === 'blankrow'){
        //         columns.splice(index, 1)
        //     }
        // }
        // // 取真实dom宽度
        // // 如果有合计行就取合计行的col，否则会取到两份col
        // let tableDom = isTotal ? tableScope.table.querySelector('.total-row') : tableScope.table;
        // let colColumns = tableDom.querySelectorAll('.u-table-scroll .u-table-header colgroup col');
        // let leftColumns = tableDom.querySelectorAll('.u-table-fixed-left .u-table-header colgroup col');
        // let rightColumns = tableDom.querySelectorAll('.u-table-fixed-right .u-table-header colgroup col');
        // for (let i = 0, len = columns.length; i < len; i++) {
        //     //兼容多表头
        //     let childnum = 0; //子表头个数
        //     if (columns[i].children) {
        //         columns[i].children.map((child, childIndex) => {
        //             child.width = colColumns[i + childIndex].style.width;
        //         });
        //         childnum += columns[i].children.length - 1;
        //     } else {
        //         let obj = { ...columns[i] };
        //         if (obj.fixed === 'left') {
        //             obj.width = leftColumns[i + childnum].style.width;
        //         } else if (obj.fixed === 'right') {
        //             obj.width = rightColumns[0].style.width;
        //         } else {
        //             obj.width = colColumns[i + childnum - leftColumns.length].style.width;
        //         }
        //         newColumns.push(obj)
        //     }
        // }
        let metaColums = [],
            ajaxColums = [];
        newColumns.forEach(val => {
            let { attrcode, width } = val;
            //前端默认拼的120默认宽度不保存到后端
            let ajaxWidthNS,
                metaWidthNS,
                title,
                propertyId;
            if (typeof width === 'string') {
                ajaxWidthNS = width.match(/\d+/g)[0];
                metaWidthNS = width.match(/\d+/g)[0];
            } else if (typeof width === 'number') {
                ajaxWidthNS = width.toFixed(0);
                metaWidthNS = width.toFixed(0);
            }
            // 后端不需要120px 前端需要
            if (ajaxWidthNS && (ajaxWidthNS == 120 || ajaxWidthNS == '120')) {
                ajaxWidthNS = undefined;
            }
            columnsHaveTitle &&
                columnsHaveTitle.length &&
                columnsHaveTitle.forEach(item => {
                    if (attrcode === item.code) {
                        title = item.label || item.display || item.value;
                        propertyId = item.pk_form_property;
                    }
                });
            let ajaxWidthObj = ajaxWidthNS ? { width: ajaxWidthNS } : {};
            let metaWidthObj = metaWidthNS ? { width: Number(metaWidthNS) } : {};
            let enableCol = this.deleteVDom(val);

            metaColums.push({
                ...enableCol,
                ...metaWidthObj,
                propertyId,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
            ajaxColums.push({
                ...enableCol,
                ...ajaxWidthObj,
                propertyId,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
        });
        let { rightData } = this.state;

        let ajax = [...rightData];
        ajax.forEach(item => {
            ajaxColums.map(ii => {
                if (ii.propertyId === item.propertyId) {
                    item.width = ii.width;
                }
            });
        });
        this.onSave(metaColums, ajax, json['table_colseting_tip01'], true); //'列宽保存成功'
    };

    //删除列里可能包含虚拟dom的字段
    deleteVDom = col => {
        let excludeVDom = Object.assign({}, col);
        delete excludeVDom.title;
        delete excludeVDom.sorter;
        delete excludeVDom.render;
        delete excludeVDom.width;
        return excludeVDom;
    };

    // platform.template.resetwidth
    // 重置列宽
    resetWidth = () => {
        let { colsSettingParam, tableScope } = this.props;
        let { appcode, pagecode, code, pageid, areaCode, tableType, tabName } = colsSettingParam;
        let { json = {} } = tableScope.state;
        //添加重置列宽的标识
        tableScope.resetWidthFlag = true;
        //添加保存列宽的标识
        tableScope.setCustomerColumnWidthFlag = true;
        // 兼容cardtable多页签
        let finalAreaCode = areaCode;
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        let url = '/nccloud/platform/template/resetwidth.do';

        ajax({
            url,
            data: {
                templateId: pageid,
                areaId: finalAreaCode,
            },
            success: res => {
                if (res.success) {
                    ajax({
                        url: '/nccloud/platform/template/getUserTemplateMap.do',
                        data: {
                            appcode,
                            pagecode,
                            templatecode: code,
                            templateId: pageid,
                        },
                        success: result => {
                            // removeGlobalStorage('localStorage', this.keySessionS);
                            removeMetaCache(appcode, pagecode);

                            let areaList = result.data[0].areaList;
                            let items = areaList.filter(item => item.code == finalAreaCode)[0].formPropertyList || [];
                            let { columns } = this.props;
                            let oldColums = columns.filter(val => val.itemtype !== 'customer' || val.changeMetaCol === true);

                            let metaColumns = [];
                            oldColums.map(oldItem => {
                                let width = 120,
                                    title;
                                items.map(newItem => {
                                    if (newItem.code == oldItem.attrcode) {
                                        width = Number(newItem.width) || 120;
                                        title = newItem.label;
                                    }
                                });
                                let enableCol = this.deleteVDom(oldItem);

                                metaColumns.push({
                                    ...enableCol,
                                    width,
                                    title,
                                });
                            });

                            this.onSuccess(metaColumns, json['table_colseting_tip03'], finalAreaCode, true);
                        },
                        error: err => {
                            this.onRequestError(err);
                        },
                    });
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    autoFold = () => {
        let { tableScope, colsSettingParam } = this.props;
        let { state, props } = tableScope;
        let { foldingRowChange, foldCacheId } = props;
        let { isEllipsis } = state;
        let newIsEllipsis = !isEllipsis
        tableScope.setState({ isEllipsis: newIsEllipsis })
        isFunction(foldingRowChange) && foldingRowChange(newIsEllipsis)
        let { appcode, pagecode, areaCode } = colsSettingParam
        let fold_localStorage

        let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;

        if (!appcode || !pagecode || !areaCode) {
            fold_localStorage = foldCacheId + '_' + userid
        } else {
            fold_localStorage = 'foldFlag_' + appcode + '_' + pagecode + '_' + areaCode + '_' + userid;
        }
        if (fold_localStorage) {
            let fold_flag = getGlobalStorage('localStorage', 'fold_flag') || {}
            if (typeof fold_flag === 'string') {
                fold_flag = JSON.parse(fold_flag)
            }
            if (newIsEllipsis === false) {
                fold_flag[fold_localStorage] = 'isFold'
                setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(fold_flag))
            } else {
                delete fold_flag[fold_localStorage]
                setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(fold_flag))
            }
        }
    }

    render() {
        let { secondColumnShow, showDrawer, sortData, displayData } = this.state;
        let { tableScope, cancelColSetting, columnWidthConfig } = this.props;
        let { state, props } = tableScope;
        let { json = {}, isEllipsis } = state;
        let { isDrag = true, showWidthAndHeightConfig = true } = props;
        return (
            <Fragment>
                {/* <li className="MouseRightListItem">过滤（ctrl+f）</li> */}
                {isDrag && showWidthAndHeightConfig && (
                    <li
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}
                        className="MouseRightListItem columnWidthSetting hasChildMenu"
                    >
                        <span>
                            {json['table_colseting_width']}
                            {/* 宽高设置 */}
                        </span>
                        {secondColumnShow && (
                            <div className="second">
                                <ul className="rightMenu secondColumn" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                                    <li className="MouseRightListItem" onClick={this.autoFold}>
                                        <div>
                                            <span className={'rightMenu-fold'}>
                                                <Checkbox
                                                    className={'fold-checkbox'}
                                                    checked={!isEllipsis}
                                                    onChange={this.autoFold}
                                                />
                                                {json["table_colseting_tip15"]}{/*自动换行 */}
                                            </span>
                                        </div>
                                    </li>
                                    {columnWidthConfig && <li className="MouseRightListItem">
                                        {/* <li className="MouseRightListItem"> */}
                                        <div
                                            onClick={() => {
                                                this.getColIncludeTitle(false, true, this.onTableWithSave);
                                            }}
                                        >
                                            {json['table_colseting_savewidth']}
                                            {/* 保存列宽 */}
                                        </div>
                                    </li>}
                                    {columnWidthConfig && <li className="MouseRightListItem">
                                        {/* {<li className="MouseRightListItem"> */}
                                        <div
                                            onClick={() => {
                                                this.resetWidth();
                                            }}
                                        >
                                            {json['table_colseting_reset']}
                                            {/* 重置 */}
                                        </div>
                                    </li>}
                                </ul>
                            </div>
                        )}
                    </li>
                )}

                {!cancelColSetting && <li className="MouseRightListItem columnOrder">
                    <div onClick={this.toShowDrawer}>
                        {json['table_colseting_table']}
                        {/* 列表设置 */}
                    </div>
                </li>}

                {showDrawer && (
                    <ColSettingSideBox
                        leftData={displayData}
                        tableScope={tableScope}
                        rightData={sortData}
                        onColsSetting={this.onColsSetting}
                        onColReset={this.onColReset}
                        toCloseDrawer={this.toCloseDrawer}
                    />
                )}
            </Fragment>
        );
    }
}
